import { DocumentAttribute } from './DocumentAttribute';
import { IFileStoreItem } from '../interfaces/IFileStoreItem';
import { BaseDocument } from '../../base/BaseDocument';
import { IDictionary } from '../../interfaces/idictionary';
import { AttributeDisplayInfo } from './attribute-display-info';

export class Document extends BaseDocument {
  typeId: string;
  type: string;
  name: string;
  description: string;
  files: IFileStoreItem[];
  hasFiles?: Boolean;
  attributes: DocumentAttribute[];
  link?: string;
  image?: string;
  left?: DocumentAttribute;
  right?: DocumentAttribute;
  tooltip?:string;
  attributeInfos?:IDictionary<AttributeDisplayInfo>;
  errors?: { [key: string]: string };
    /**
     *
     */
    constructor() {
      super();
      this.attributes = [];
    }
  }
